<template>
  <div>
    <div class="row">
      <!-- INPUT TEXTBOX -->
      <div class="col-12">
        <el-form label-position="right" label-width="72px" @submit.native.prevent="go">
          <el-form-item label="關鍵字">
            <el-input maxlength="240px" placeholder="（search keyword）"
              v-model="keyword" clearable>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- RADIO GROUP OF PROPS -->
      <div class="col-12">
        <el-radio-group v-model="prop" size="small">
          <el-radio-button v-for="sp in searchProps" :key="sp.value" :label="sp.value">
            {{ sp.label }}
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeywordWidget',
  props: {
    searchProps: {
      type: Array,
      default: () => [ ]
    }
  },

  mounted() {
    // Put 'prop' on the first prop.
    if (this.searchProps.length)
      this.prop = this.searchProps[0]['value'];
  },

  methods: {
    go() {
      this.$emit('change', { prop: this.prop, keyword: this.keyword });
    }
  },

  data() {
    return {
      keyword: '',
      prop: ''
    };
  }
}
</script>